/**
 * @fileoverview Singer Settings Page
 * @summary Wrapper that uses the shared UserSettingsPage for singers
 * 
 * @package KaraoNow
 * @module apps/front/src/pages/singer/SingerSettingsPage
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks/redux.js'
import UserSettingsPage from '../UserSettingsPage.js'
import { ProfileFormSinger } from './components/ProfileFormSinger.js'
import { updatePreferences } from '../../store/slices/authSlice.js'
import { useNavigate } from 'react-router-dom'

/**
 * @summary Singer Settings Page
 * @returns {React.ReactElement} Singer Settings Page
 */
export default function SingerSettingsPage() {
  const navigate = useNavigate()
  const user = useAppSelector((state) => state.auth.user)
  const dispatch = useAppDispatch()

  // Profile state
  const [firstName, setFirstName] = useState(user?.profile?.firstName || '')
  const [lastName, setLastName] = useState(user?.profile?.lastName || '')
  const [pseudo, setPseudo] = useState(user?.profile?.pseudo || '')
  const [email, setEmail] = useState(user?.email || '')
  const [isSaving, setIsSaving] = useState(false)
  
  const handleSaveProfile = async () => {
    
    try {
      setIsSaving(true)

      // Build preferences object with profile and email if changed
      const preferences: any = {
        profile: {
          firstName,
          lastName,
          pseudo,
        },
      }

      // Add email if it has changed
      if (email !== user?.email) {
        preferences.email = email
      }

      await dispatch(updatePreferences(preferences)).unwrap()
    } finally {
      setIsSaving(false)
      navigate('/')
    }
  }

  const profileForm = (
    <ProfileFormSinger
      firstName={firstName}
      lastName={lastName}
      pseudo={pseudo}
      email={email}
      pendingEmail={user?.pendingEmail}
      isSaving={isSaving}
      onFirstNameChange={setFirstName}
      onLastNameChange={setLastName}
      onPseudoChange={setPseudo}
      onEmailChange={setEmail}
      onSave={handleSaveProfile}
    />
  )

  return <UserSettingsPage i18nPrefix="singer" profileFormComponent={profileForm} />
}
